import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");

      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }

      try {
        const response = await axios.post(`${API}/auth/google/callback`, {
          session_id: sessionId,
        });

        const { token, role, name, user_id, email, company } = response.data;

        // Clear any existing auth
        localStorage.clear();

        if (role === "client") {
          localStorage.setItem("clientToken", token);
          localStorage.setItem("clientName", name);
          localStorage.setItem("clientEmail", email);
          localStorage.setItem("clientUserId", user_id);
          localStorage.setItem("clientCompany", company || "");
          // Clean URL and redirect
          window.history.replaceState({}, "", "/portal/dashboard");
          navigate("/portal/dashboard", { replace: true });
        } else {
          localStorage.setItem("adminToken", token);
          localStorage.setItem("adminRole", role);
          localStorage.setItem("adminName", name);
          localStorage.setItem("adminUserId", user_id || "");
          window.history.replaceState({}, "", "/admin/dashboard");
          navigate("/admin/dashboard", { replace: true });
        }
      } catch {
        navigate("/?login=true", { replace: true });
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#191b1d] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="w-10 h-10 animate-spin text-[#ff3737] mx-auto mb-4" />
        <p className="text-[#ebebeb]/60 text-sm">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
